import { useCurrentStateAndParams } from "@uirouter/react";

import { SI_SEARCH_ROUTES } from "app/common/constants/ad-intelligence-routes";
import { ROUTES } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingConstants";

export interface ILandingPagesEndpoints {
    table: string;
    excel: string;
    totalPagesPerSite: string;
    drillDownExcel: string;
    tableDrillDown: string;
    tableDrillDownTrend: string;
    pageAds: string;
}

const keywordLandingPagesEndpoints: ILandingPagesEndpoints = {
    table: "/api/websiteOrganicLandingPagesV2",
    excel: "/api/websiteOrganicLandingPagesV2/Excel",
    totalPagesPerSite: "/api/websiteOrganicLandingPagesV2/GetTotalPagesPerSite",
    drillDownExcel: "/api/websiteOrganicLandingPagesV2/DrillDownExcel",
    tableDrillDown: "/api/websiteOrganicLandingPagesV2/GetTableDrillDown",
    tableDrillDownTrend: "/api/websiteOrganicLandingPagesV2/GetTableDrillDownTrend",
    pageAds: "/api/websiteOrganicLandingPagesV2/GetPageAds",
};

const searchAdsLandingPagesEndpoints: ILandingPagesEndpoints = {
    table: "/api/AdIntelligence/Search/websiteLandingPages",
    excel: "/api/AdIntelligence/Search/websiteLandingPages/Excel",
    totalPagesPerSite: "/api/AdIntelligence/Search/websiteLandingPages/GetTotalPagesPerSite",
    drillDownExcel: "/api/AdIntelligence/Search/websiteLandingPages/DrillDownExcel",
    tableDrillDown: "/api/AdIntelligence/Search/websiteLandingPages/GetTableDrillDown",
    tableDrillDownTrend: "/api/AdIntelligence/Search/websiteLandingPages/GetTableDrillDownTrend",
    pageAds: "/api/AdIntelligence/Search/websiteLandingPages/GetPageAds",
};

const landingPagesEndpointsMap: Record<string, ILandingPagesEndpoints> = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    organicsearch_website_landingpages_v2: keywordLandingPagesEndpoints,
    [ROUTES.landingPages]: searchAdsLandingPagesEndpoints,
    // Sales Intelligence mirror of Search Advertising.
    [SI_SEARCH_ROUTES.landingPages]: searchAdsLandingPagesEndpoints,
};

export const useLandingPagesEndpoints = (): ILandingPagesEndpoints => {
    const { state } = useCurrentStateAndParams();
    const endpoints = landingPagesEndpointsMap[state.name];

    if (!endpoints) {
        throw new Error(
            `No landing pages endpoints configured for state: ${state.name}. ` +
                `Available states: ${Object.keys(landingPagesEndpointsMap).join(", ")}`,
        );
    }

    return endpoints;
};
